import type {
  ElementType,
  HTMLAttributes,
} from 'react';
import classNames from 'classnames';

import styles from './Text.module.css';

type TextProps = HTMLAttributes<HTMLSpanElement> & {
  as?: ElementType;
  kind?: 'label' |
         'caption' |
         'control' |
         'paragraph' |
         'heading-1' |
         'heading-2' |
         'heading-3' |
         'heading-4' |
         'heading-5' |
         'heading-6' |
         'super';
  size?: 'small' |
         'regular' |
         'large';
  weight?: '100' |
           '200' |
           '300' |
           '400' |
           '500' |
           '600' |
           '700' |
           '800' |
           '900' |
           'inherit';
  color?: 'neutral' |
          'neutral-50' |
          'neutral-100' |
          'neutral-200' |
          'neutral-500' |
          'neutral-600' |
          'neutral-800' |
          'primary-50' |
          'primary-200' |
          'primary-500' |
          'primary-600' |
          'primary-700' |
          'danger' |
          'warning';
  serif?: boolean;
}

const Text = (props: TextProps) => {
  const {
    as: Component = 'span',
    kind,
    size,
    color,
    weight,
    serif = false,
    children,
    className,
  } = props;

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const textClassName = classNames({
    [styles.text]: true,
    [styles[kind]]: !!kind,
    [styles[size]]: !!size,
    [styles.serif]: !!serif,
    [styles[color]]: !!color,
    [styles[`w${weight}`]]: !!weight,
    [className]: !!className,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <Component className={textClassName}>
      {children}
    </Component>
  );
};

export default Text;
export type { TextProps };
